export default __webpack_public_path__ + "static/media/u5-ubahn-neubauprojekte-wien.596ffe1f.svg";